import React, { useState, Fragment } from 'react'
import cx from 'classnames'
import { trim } from 'libraries/lodash'
import FacetOption from './FacetOption'
import Icon from 'components/shared/Icon'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import IconButton from '@mui/material/IconButton'
import TealToolTip from 'components/TealToolTip'

const Facet = ({ options, name, parameterName, handleFacetOptionClick }) => {
  const [expanded, setExpanded] = useState(false)
  const [hidden, setHidden] = useState(false)

  const handleClick = () => setExpanded(!expanded)
  const handleHideToggle = () => setHidden(!hidden)

  const getOptionsList = (_expanded) => {
    if (name && name.toLowerCase() === 'area of law') {
      return options
    }
    if (_expanded) {
      return options
    }
    const selected = options.filter(opt => opt.selected)
    if (selected.length) {
      return selected
    }
    return options.slice(0, 3)
  }

  const canExpand = getOptionsList(false).length < options.length
  const facetOptions = getOptionsList(expanded).filter(opt => opt.parentId === 0).filter(({ name }) => trim(name))

  return (
    <div className='pv3'>
      <div className='flex justify-between items-center'>
        <h4 className='mv1 f5 fw6 black lh-copy'>
          {options.length >= 15 ? `${name} (Top ${options.length})` : name}
        </h4>
        <TealToolTip title={hidden ? 'Show' : 'Hide'} placement='right'>
          <IconButton
            size='small'
            classes={{ root: 'black outline-0' }}
            onClick={handleHideToggle}
          >
            <Icon className='w6' name={hidden ? 'icon-plus' : 'icon-minus'} />
          </IconButton>
        </TealToolTip>
      </div>
      <div>
        {!hidden && facetOptions.map(option => (
          <Fragment key={option.name}>
            <FacetOption {...{ ...option, parameterName, handleFacetOptionClick }} />
          </Fragment>
        ))}
        {canExpand && !hidden && (
          <Expander
            {...{ hidden, expanded }}
            handleClick={handleClick}
            howMany={options.length - facetOptions.length}
          />
        )}
      </div>
    </div>
  )
}

const Expander = ({ hidden, handleClick: onClick, expanded, howMany }) => {
  const className = cx(
    'f7 flex items-center hover-underline cadet-blue transition-all items-center ml7 mt2 pointer',
    {
      dn: hidden,
      flex: !hidden
    }
  )

  return (
    <a href={null} {...{ className, onClick }} data-testid={expanded ? 'facets-see-less' : 'facets-see-more'}>
      <span className=''>
        {expanded ? 'see less' : `see ${howMany} more`}
      </span>
      {!expanded && <ArrowDropDownIcon htmlColor='black' />}
      {expanded && <ArrowDropUpIcon htmlColor='black' />}
    </a>
  )
}

export default Facet
